module.exports = __webpack_public_path__ + "static/media/icon-catalog-products-done.e77e7e5a.svg";